module.exports = __webpack_public_path__ + "img/zs_17@2x.ef4eefe4.png";